import * as React from 'react';
import * as  apiService from '../../store/apiService';

// custom component
import TableCellwithColors from '../../sharedcomponents/TableCellwithColors';
import { sortDatebySelection, sortNumber, sortCurrency } from '../../helpers/sortingHelper';

// devextremene grid
import {
    SearchState,
    FilteringState,
    IntegratedFiltering,
    PagingState,
    SortingState,
    CustomPaging,
    IntegratedPaging,
    IntegratedSorting,
    EditingState
} from '@devexpress/dx-react-grid';
import Paper from '@material-ui/core/Paper';
import {
    Grid,
    Table,
    Toolbar,
    SearchPanel,
    TableHeaderRow,
    TableFilterRow,
    PagingPanel,
    TableColumnVisibility,
    ColumnChooser
} from '@devexpress/dx-react-grid-material-ui';

// @ts-ignore
const ColumnCell = ({ getMessage, column, ...restProps }) => (
    // @ts-ignore
    <TableHeaderRow.Cell
        column={column}
        getMessage={() => column.title}
        {...restProps}
    />
);

// @ts-ignore
const Cell = ({ value, ...restProps }) => {
    const { column } = restProps;
    if (column.name === 'due_date') {
        if (restProps.row.due_date === "") {
            return <td><div>{restProps.row.CreatedAt}</div></td>
        } else {
            return <td><div style={{ color: 'red' }}>{restProps.row.due_date}</div></td>
        }
    }
    if (column.name === 'contact_name') {
        return <td>
            <div className="openModsReport_contact_name">
                <div>
                    {restProps.row.contact_name}
                </div>
                <div>
                    {restProps.row.contact_phone}
                </div>
                <div>
                    {restProps.row.contact_email}
                </div>
            </div>
        </td>;
    }
    if (column.name === 'property_name' && restProps.tableRow.row.dsi_point_person !== undefined) {
        return <td>
            <div className="openModsReport_client_name">
                <a style={{ color: 'lightblue' }} onClick={() => handleClickPropNum(restProps.row.property_number)}>
                    <i className="fa fa-trash-alt"></i>
                    {restProps.row.property_number}
                </a> - {restProps.row.property_name}
            </div>
        </td>
    }
    if (column.name === 'property_number') {
        return <td><div><a style={{ color: 'lightblue' }} onClick={() => handleClickPropNum(restProps.row.property_number)}><i className="fa fa-trash-alt"></i>{restProps.row.property_number}</a></div></td>
    }
    if (column.name === 'content') {
        if (restProps.row.content === 'Yes') {
            return <TableCellwithColors color="#00bb00" />
        } else if (restProps.row.content === 'No') {
            return <TableCellwithColors color="#d63636" />
        } else {
            return <td><div className="text-center"> N/A </div></td>;
        }
    }
    if (column.name === 'approval') {
        if (restProps.row.approval === 'Approved') {
            return <TableCellwithColors color="green" />
        } else if (restProps.row.approval === 'Pending') {
            return <TableCellwithColors color="yellow" />
        } else if (restProps.row.approval === 'Required') {
            return <TableCellwithColors color="red" />
        } else {
            return <td><div className="text-center"> N/A </div></td>;
        }
    }
    if (column.name === 'graphics') {
        if (restProps.row.graphics === 'Yes') {
            return <TableCellwithColors color="#00bb00" />
        } else if (restProps.row.graphics === 'No') {
            return <TableCellwithColors color="#d63636" />
        } else {
            return <td><div className="text-center"> N/A  </div></td>;
        }
    }
    if (column.name === 'programming') {
        if (restProps.row.programming === 'Yes') {
            return <TableCellwithColors color="#00bb00" />
        } else if (restProps.row.programming === 'No') {
            return <TableCellwithColors color="#d63636" />
        } else {
            return <td><div> N/A </div></td>;
        }
    }
    if (column.name === 'transferred') {
        if (restProps.row.transferred === 'Yes') {
            return <TableCellwithColors color="#00bb00" />
        } else if (restProps.row.transferred === 'No') {
            return <TableCellwithColors color="#d63636" />
        } else {
            return <td ><div className="text-center"> N/A </div></td>;
        }
    }
    if (column.name === 'invoiced') {
        if (restProps.row.invoiced === 'Yes') {
            return <TableCellwithColors color="#00bb00" />
        } else if (restProps.row.invoiced === 'No') {
            return <TableCellwithColors color="#d63636" />
        } else {
            return <td><div className="text-center"> N/A </div></td>;
        }
    }

    // @ts-ignore
    return <Table.Cell {...restProps} >
        <span title={value}>{value}</span>
    </Table.Cell>
};

function handleClickPropNum(args: any) {
    window.open(apiService.atlaslink(args), "_blank")
}

class ModReportsGrid extends React.Component<any, any> {
    public changeCurrentPage: any;
    public changePageSize: any;

    constructor(props: any) {
        super(props);
        this.state = {
            defaultColumnWidths: [
                { columnName: 'due_date', width: 180 },
                { columnName: 'car', width: 240 },
            ],
            tableColumnExtensionsOpenMods: [
                { columnName: 'property_name', align: 'left' },
                { columnName: 'due_date', align: 'center', },
                { columnName: 'dsi_point_person', align: 'center' },
                { columnName: 'contact_name', align: 'left' },
                { columnName: 'dsi_point_person', align: 'center' },
                { columnName: 'description', align: 'center' },
                { columnName: 'cost', align: 'center' },
                { columnName: 'content', align: 'center' },
                { columnName: 'approval', align: 'center' },
                { columnName: 'graphics', align: 'center' },
                { columnName: 'programming', align: 'center' },
                { columnName: 'transferred', align: 'center' },
                { columnName: 'invoiced', align: 'center' }
            ],
            tableColumnExtensions: [
                { columnName: 'due_date', width: 110 },
                { columnName: 'dsi_point_person' },
                { columnName: 'contact_name' },
                { columnName: 'dsi_point_person' },
                { columnName: 'description' },
                { columnName: 'cost', width: 180 },
                { columnName: 'content', width: 80 },
                { columnName: 'approval', width: 80 },
                { columnName: 'graphics', width: 80 },
                { columnName: 'programming', width: 80 },
                { columnName: 'transferred', width: 80 },
                { columnName: 'invoiced', width: 80 },
                // Mod Quotes
                { columnName: 'property_number', width: 110 },
                { columnName: 'property_name' },
                { columnName: 'tsi_contact', width: 250 },
                { columnName: 'product_1_desc' },
                { columnName: 'create_date', width: 110 }
            ],
            tableColumnExtensionsModsQuotes: [
                { columnName: 'property_number', align: 'left' },
                { columnName: 'property_name', align: 'center', },
                { columnName: 'tsi_contact', align: 'center' },
                { columnName: 'product_1_desc', align: 'left' },
                { columnName: 'create_date', align: 'center' }
            ],
            rowsOpenMods: [],
            rowsModsQuotes: [],
            sorting: [{ columnName: 'due_date', direction: 'asc' }],
            sortingModQuotes: [{ columnName: 'property_number', direction: 'asc' }],
            totalCount: 0,
            totalCountModQuotes: 0,
            pageSize: 10,
            pageSizes: [10, 15, 30, 50],
            integratedSortingColumnExtensions: [
                { columnName: 'due_date', compare: sortDatebySelection },
                { columnName: 'cost', compare: sortCurrency },
                { columnName: 'create_date', compare: sortDatebySelection },
                { columnName: 'property_number', compare: sortNumber }
            ],
            dateColumns: ['due_date'],
            filteringColumnExtensions: [
                {
                    columnName: 'property_name',
                    predicate: (value: any, filter: any, row: any) => {
                        if (filter.value) {
                            return this.PropertyNamePredicate(value, filter, row);
                        } else {
                            return true
                        }
                    },
                },
                {
                    columnName: 'contact_name',
                    predicate: (value: any, filter: any, row: any) => {
                        if (filter.value) {
                            return this.ContactNamePredicate(value, filter, row);
                        } else {
                            return true
                        }
                    },
                },
            ],
        };

        this.changeCurrentPage = (currentPage: any) => this.setState({ currentPage });
        this.changePageSize = (pageSize: any) => this.setState({ pageSize });
    }

    public PropertyNamePredicate = (value: any, filter: any, row: any) => {
      
            return String(row.property_number).indexOf(String(filter.value)) !== -1 ||
                String(row.property_name.toLowerCase()).indexOf(String(filter.value.toLowerCase())) !== -1;
      
    }

    public ContactNamePredicate = (value: any, filter: any, row: any) => {
        return String(row.contact_name.toLowerCase()).indexOf(String(filter.value.toLowerCase())) !== -1 ||
            String(row.contact_phone.toLowerCase()).indexOf(String(filter.value.toLowerCase())) !== -1 ||
            String(row.contact_email.toLowerCase()).indexOf(String(filter.value.toLowerCase())) !== -1;
    }

    public commitChanges(deleted: any) {
        console.log(deleted);
        let { rows } = this.state;
        if (deleted) {
            const deletedSet = new Set(deleted);
            rows = rows.filter((row: any) => !deletedSet.has(row.id));
            console.log(rows);
        }
        this.setState({ rows });
    }

    public addNewgenerateHTML(args: any) {
        return (
            <div>{args}</div>
        )
    }

    public render() {
      const {
            sorting,
            filteringColumnExtensions,
            integratedSortingColumnExtensions,
            tableColumnExtensions,
            pageSize,
            pageSizes,
            currentPage,
            totalCount,
        } = this.state;
        return (
            <div>
                <Paper className="papergrid" style={{ position: 'relative' }}>
                    <Grid
                        rows={this.props.rows}
                        columns={this.props.columns}
                    >
                        <EditingState onCommitChanges={this.commitChanges} />
                        <SearchState defaultValue="" />
                        <FilteringState
                            defaultFilters={[]}
                            columnExtensions={[
                                { columnName: 'content', filteringEnabled: false },
                                { columnName: 'approval', filteringEnabled: false },
                                { columnName: 'graphics', filteringEnabled: false },
                                { columnName: 'programming', filteringEnabled: false },
                                { columnName: 'transferred', filteringEnabled: false },
                                { columnName: 'invoiced', filteringEnabled: false },
                            ]}
                        />
                        <IntegratedFiltering columnExtensions={filteringColumnExtensions} />
                        <SortingState
                            sorting={sorting}
                            defaultSorting={sorting}
                        />
                        <IntegratedSorting
                            columnExtensions={integratedSortingColumnExtensions}
                        />
                        <PagingState
                            defaultCurrentPage={0}
                            currentPage={currentPage}
                            onCurrentPageChange={this.changeCurrentPage}
                            pageSize={pageSize}
                            onPageSizeChange={this.changePageSize}
                        />
                        <CustomPaging
                            totalCount={totalCount}
                        />
                        <IntegratedPaging />
                        <Table
                            columnExtensions={tableColumnExtensions}
                            cellComponent={Cell}
                        />
                        <TableHeaderRow
                            showSortingControls={true}
                            cellComponent={ColumnCell}
                        />
                        <TableFilterRow
                            showFilterSelector={false}
                        />
                        <TableColumnVisibility
                            defaultHiddenColumnNames={['']}
                        />
                        <Toolbar />
                        <SearchPanel />
                        <PagingPanel
                            pageSizes={pageSizes}
                        />
                        <ColumnChooser />
                    </Grid>
                </Paper>
            </div>
        );
    }
}
export default ModReportsGrid;


// WEBPACK FOOTER //
// ./src/components/Open Mods/modsReportGrid.tsx